"use strict";

exports.__esModule = true;
exports.PI2 = exports.scale = void 0;
var scale = window && window.devicePixelRatio ? window.devicePixelRatio : 1;
exports.scale = scale;
var PI2 = Math.PI * 2;
exports.PI2 = PI2;